import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HandleErrorService } from 'app/core/services/handle-error';

@Injectable()
export class HandleErrorsInterceptor implements HttpInterceptor {
	constructor(private handleErrorService: HandleErrorService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				let errorMsg = '';
				if (error.error instanceof ErrorEvent) {
					errorMsg = `Error: ${error.error.message}`;
				} else {
					errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
				}
				this.handleErrorService.handleError(error);
				return throwError(() => errorMsg);
			})
		);
	}
}
